import { Controller } from "stimulus"

export default class extends Controller {
  focusReceipt(event) {
    var tableRow = event.target.closest('tr')
    tableRow.dataset.active = (tableRow.dataset.active === "true") ? "" : "true";
    var url = tableRow.dataset.href;
    url = url.replace(/\?.*$/, '?only_image=1');
    if(tableRow.dataset.active) {
      Rails.ajax({
        type: 'GET',
        url: url,
        success: function(response) {
          document.getElementById('focused_reciept').innerHTML = response.body.innerHTML;
        },
        error: function(response, status, request) { }
      });
    }
  }
}